const CATEGORY_ICONS = {
    'Canned Goods': '🥫',
    'Dry Goods': '🌾',
    'Produce': '🥦',
    'Dairy': '🥛',
    'Frozen': '🧊',
    'Meat': '🥩',
    'Bakery': '🍞',
    'Personal Care': '🧴',
};

export const categoryIcon = (name) => CATEGORY_ICONS[name] ?? '📦';
